module.exports = __webpack_public_path__ + "files/d53461b26e5493782ca425691d30aed2.png";